import { gql } from '@apollo/client'

export const USERS_ONLINE = gql`
    query UsersOnline {
        site {
            guid
            usersOnline
        }
    }
`
